// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","351":"commons","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"6f53c2a454e0046e1e99","351":"74391a38469c6cbd1e91","532":"34a9ae9fcd631f84baee","691":"86d71d1a92f3c1fd8b1a"}[chunkId] + ".js";
};